export const app = {
  connectToYourWhatsappNumber: 'Подключиться к вашему номеру WhatsApp',
  connectYourWhatsappBotWithYourWhatsappNumber: 'Подключите вашего бота WhatsApp к вашему номеру WhatsApp',
  connect: 'Подключить',
};
